<template>
  <v-application>
    <v-layout class="ma-2">
      <v-flex v-bind:md6="!large" v-bind:md8="large">
        <v-dialog v-model="receive_dialog" max-width="400" width="400">
          <v-card>
            <v-card-title>Receive transfer order</v-card-title>
            <v-card-text
              >Are you sure you want to receive all items?</v-card-text
            >
            <v-card-actions>
              <v-spacer />
              <v-btn text v-on:click="receive_dialog = false">{{
                $t("cancel")
              }}</v-btn>
              <v-btn text color="primary" v-on:click="receiving">{{
                $t("receive")
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-card class="mb-3">
          <v-toolbar flat dense>
            <v-btn small text v-on:click="backClicked">
              <v-icon>mdi-chevron-left</v-icon>
              {{ $t(title) }}
            </v-btn>
            <v-spacer />
            <template v-if="!noReceive">
              <v-btn
                small
                text
                v-if="data.status != 'closed' && data.status != 'transferred'"
                v-on:click="receiving"
                >{{ $t("receive") }}</v-btn
              >
            </template>
            <template v-if="count">
              <v-btn
                small
                text
                v-if="data.status == 'in_progress' || data.status == 'pending'"
                v-on:click="counting"
                >Count stock</v-btn
              >
            </template>
            <template v-if="!mobile && !noEdit">
              <v-btn
                text
                small
                v-if="
                  data.status == 'pending' ||
                  data.status == 'in_transit' ||
                  data.status == 'in_progress'
                "
                v-on:click="
                  $router.push({ path: to + '/update', query: $route.query })
                "
                >{{ $t("edit") }}</v-btn
              >
              <!--<v-btn text small>Send</v-btn>-->
            </template>
            <v-menu v-bind:close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on" small v-bind:icon="mobile">
                  <template v-if="!mobile">{{ $t("more") }}</template>
                  <v-icon>{{
                    mobile ? "mdi-dots-vertical" : "mdi-chevron-down"
                  }}</v-icon>
                </v-btn>
              </template>
              <v-list>
                <template v-if="mobile && !noEdit">
                  <v-list-item
                    v-if="
                      data.status == 'pending' ||
                      data.status == 'in_transit' ||
                      data.status == 'in_progress'
                    "
                    v-on:click="
                      $router.push({
                        path: to + '/update',
                        query: $route.query,
                      })
                    "
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ $t("edit") }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <!--<v-list-item v-on:click="() => {}">
                    <v-list-item-content>
                      <v-list-item-title>Send</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>-->
                </template>
                <v-list-item
                  v-if="
                    (!invPurchase && !invStock && !invProduction) ||
                    (user_access &&
                      ((invPurchase && user_access.inv_purchase_orders_cost) ||
                        (invStock && user_access.inv_stock_adjusment_cost) ||
                        (invProduction && user_access.inv_productions_cost)))
                  "
                  v-on:click="downloadPdf"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <!-- <a :href="pdfLink" style="text-decoration: none; color: black" download> -->
                      Save as PDF
                      <!-- </a> -->
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  v-if="
                    (!invPurchase && !invStock && !invProduction) ||
                    (user_access &&
                      ((invPurchase && user_access.inv_purchase_orders_cost) ||
                        (invStock && user_access.inv_stock_adjusment_cost) ||
                        (invProduction && user_access.inv_productions_cost)))
                  "
                  v-on:click="downloadXls"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <!-- <a :href="pdfLink" style="text-decoration: none; color: black" download> -->
                      Save as XLS
                      <!-- </a> -->
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <!-- <v-list-item v-on:click="() => {}">
                  <v-list-item-content>
                    <v-list-item-title>Save as CSV</v-list-item-title>
                  </v-list-item-content>
                </v-list-item> -->
                <v-list-item v-if="!count" v-on:click="print">
                  <v-list-item-content>
                    <v-list-item-title>Print labels</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="
                    (!count && !invPurchase && !invStock && !invProduction) ||
                    (user_access &&
                      ((invPurchase && user_access.inv_purchase_orders_cost) ||
                        (invStock && user_access.inv_stock_adjusment_cost) ||
                        (invProduction && user_access.inv_productions_cost)))
                  "
                  v-on:click="pricing"
                >
                  <v-list-item-content>
                    <v-list-item-title>Pricing</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="cancel && data.status != 'closed'"
                  v-on:click="canceling"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      >Cancel remaining items</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="remove && data.status != 'closed'"
                  v-on:click="removing"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      >Delete {{ name }} order</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
          <v-divider />
          <slot name="header" v-bind:data="data" />
          <v-list-item two-line v-if="data.notes">
            <v-list-item-content>
              <v-list-item-title>
                <span class="subtitle-2">Notes:</span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span class="body-2">{{ data.notes }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <v-toolbar flat>
            <v-toolbar-title>{{ $t("items") }}</v-toolbar-title>
          </v-toolbar>

          <v-data-table
            v-bind:headers="reason ? headers[data.reason] : headers"
            v-bind:items="data.items"
            :items-per-page="200000"
            hide-default-footer
            disable-sort
            :no-data-text="$t('you_have_not_selected_items_yet')"
            :mobile-breakpoint="0"
          >
            <template v-slot:[`item.name`]="{ item }">
              <v-list-item-content>
                <p style="max-width: 700px">
                  {{ item.product_name }}
                </p>
                <v-list-item-title>
                  <!-- {{item.product_name}} -->
                  <span v-if="item.is_cancelled" class="body-2 red--text">{{
                    $t("canceled")
                  }}</span>
                </v-list-item-title>
                <v-list-item-subtitle>SKU {{ item.sku }}</v-list-item-subtitle>
                <v-list-item-subtitle
                  v-if="item.barcode && item.barcode.length > 0"
                >
                  Barcode
                  <span v-for="(barcode, ind) in item.barcode" :key="ind">{{
                    barcode + ", "
                  }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
            <template v-slot:[`item.cost`]="{ item }"
              >{{
                typeof item.cost === typeof 5
                  ? item.cost_currency === "usd"
                    ? item.cost.toLocaleString()
                    : Math.round(item.cost).toLocaleString()
                  : item.cost
              }}{{ item.cost_currency === "usd" ? " $" : "" }}</template
            >
            <!-- purchase view -->
            <template v-slot:[`item.purchase_cost`]="{ item }"
              >{{
                item.purchase_cost
                  ? item.purchase_cost.toLocaleString()
                  : item.purchase_cost
              }}{{
                item.purchase_cost_currency === "usd" ? " $" : ""
              }}</template
            >
            <template v-slot:[`item.amount`]="{ item }"
              >{{ item.amount ? item.amount.toLocaleString() : item.amount
              }}{{
                item.purchase_cost_currency === "usd" ? " $" : ""
              }}</template
            >
            <template v-slot:[`item.cost_difference`]="{ item }">{{
              item.cost_difference
                ? item.cost_currency === "usd"
                  ? item.cost_difference.toLocaleString() + " $"
                  : Math.floor(item.cost_difference).toLocaleString()
                : item.cost_difference
            }}</template>
          </v-data-table>
          <v-data-table
            v-if="data.additional_cost && data.additional_cost.length > 0"
            v-bind:headers="additional_cost_headers"
            v-bind:items="data.additional_cost"
            hide-default-footer
            :mobile-breakpoint="0"
          >
            <template v-slot:[`item.name`]="{ item }">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.name }}
                  <span v-if="item.is_cancelled" class="body-2 red--text">{{
                    $t("canceled")
                  }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-slot:[`item.amount`]="{ item }"
              >{{ item.amount ? item.amount.toLocaleString() : item.amount
              }}{{ item.amount_currency == "usd" ? " $" : "" }}</template
            >
          </v-data-table>
          <v-divider />
          <v-card-actions
            style="margin: 10px; padding-bottom: 10px"
            v-if="
              !noTotal ||
              (invPurchase &&
                user_access &&
                user_access.inv_purchase_orders_cost)
            "
          >
            <v-spacer />
            <span class="subtitle-2"
              >{{ $t("total") }}:
              {{ data.total ? data.total.toLocaleString() : data.total
              }}{{ data.total_currency == "usd" ? " $" : "" }}</span
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-application>
</template>
<script>
export default {
  name: "v-inventory-view",
  props: {
    name: String,
    title: String,
    large: Boolean,
    to: String,
    receive: String,
    headers: { type: [Array, Object], default: () => [] },
    remove: Boolean,
    cancel: Boolean,
    noEdit: Boolean,
    noReceive: Boolean,
    noTotal: Boolean,
    reason: Boolean,
    count: Boolean,
    invPurchase: Boolean,
    invStock: Boolean,
    invProduction: Boolean,
  },
  data: () => ({
    receive_dialog: false,
    additional_cost_headers: [
      { text: "Additional cost", value: "name" },
      { text: "Amount", value: "amount", align: "right" },
    ],
    data: {
      reason: "receive",
      status: "pending",
      is_service_changable: true,
      items: [],
      additional_cost: [],
      total: 0,
    },
    pdfLink: "",
  }),
  methods: {
    async getItems() {
      const items = this.$communicator.then(
        this,
        await this.$communicator("get_inv_count_items", {
          params: {
            service: this.data.service,
            categories: [],
            suppliers: [],
          },
        })
      );
      if (items) {
        const inStockMap = {};
        for (const index in items) {
          inStockMap[items[index]._id] = items[index].in_stock;
        }

        for (let i = 0; i < this.data.items.length; i++) {
          if (inStockMap[this.data.items[i].product_id]) {
            this.data.items[i].exp_in_stock =
              inStockMap[this.data.items[i].product_id];
          } else {
            this.data.items[i].exp_in_stock = 0;
          }
          if (
            this.data.items[i].counted - this.data.items[i].exp_in_stock ||
            this.data.items[i].counted - this.data.items[i].exp_in_stock == 0
          ) {
            this.data.items[i].difference =
              this.data.items[i].counted - this.data.items[i].exp_in_stock;
          }

          if (
            this.data.items[i].difference ||
            this.data.items[i].difference == 0
          ) {
            this.data.items[i].cost_difference =
              this.data.items[i].difference * this.data.items[i].cost;
          }
        }
      }
    },
    counting() {
      this.$router.push({
        path: this.to + "/complete",
        query: this.$route.query,
      });
    },
    async update() {
      if (this.name) {
        const data = this.$communicator.then(
          this,
          await this.$communicator(this.name + "_by_id", {
            arguments: [this.$route.query["id"]],
          })
        );
        if (data) {
          this.data = data;
          if (this.count && this.data.status != "completed") {
            this.getItems();
          }
          if (this.reason) {
            for (const index in this.headers[this.data?.reason]) {
              this.headers[this.data?.reason][index]["sortable"] = false;
            }
          }
        }
      }
    },
    async receiving() {
      if (this.receive) {
        this.$router.push({
          path: this.receive,
          query: {
            to: this.to,
            id: this.$route.query["id"],
          },
        });
      } else {
        if (this.receive_dialog == true) {
          await this.$communicator("receive_" + this.name, {
            arguments: [this.$route.query["id"]],
          });
          this.update();
          this.receive_dialog = false;
        } else {
          this.receive_dialog = true;
        }
      }
    },
    async canceling() {
      await this.$communicator("cancel_" + this.name, {
        arguments: [this.$route.query["id"]],
      });
      this.$to(this.to);
    },
    removing() {},
    print() {
      this.$router.push({
        path: "/items/create-label/print",
        query: {
          [this.name]: this.$route.query["id"],
        },
      });
    },
    pricing() {
      if (this.name == "purchase") {
        this.$router.push({
          path: "/inventory/pricing/purchase",
          query: {
            id: this.$route.query["id"],
          },
        });
      } else {
        this.$router.push({
          path: "/items/create-pricing/inv-pricing",
          query: {
            [this.name]: this.$route.query["id"],
          },
        });
      }
    },
    downloadPdf() {
      const link = `inventory/${this.name}/pdf/${this.$route.query["id"]}/${this.data.p_order}.pdf`;
      this.$communicator.downloadDocument(link, `${this.data.p_order}.pdf`);
      // this.$communicator.download(link);
    },
    downloadXls() {
      const link = `inventory/${this.name}/pdf/${this.$route.query["id"]}/${this.data.p_order}?type=exel`;
      this.$communicator.downloadDocument(
        link,
        `${this.data.p_order}?type=exel.xls`
      );
      // this.$communicator.download(link);
    },
    backClicked() {
      if (this.title == "inventory_counts") {
        this.$router.push({ path: "/inventory/counts" });
      } else {
        this.$router.go(-1);
      }
    },
  },
  mounted() {
    // if (!this.reason) {
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    // }
    for (const index in this.additional_cost_headers) {
      this.additional_cost_headers[index]["sortable"] = false;
    }
    this.update();
  },
  computed: {
    mobile() {
      return (
        this.$vuetify.breakpoint.name == "xs" ||
        this.$vuetify.breakpoint.name == "sm"
      );
    },
  },
};
</script>
